import React, { memo, useCallback, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

import {
  ModalStyled,
  ModalBackgroundStyled,
} from "../../common/ModalComponent/styles";
import {
  MissionPlannerContainerStyled,
  MissionPlannerContentStyled,
} from "../../MissionDetails/styles";

import { closeAnyModal } from "Slices/modals";
import { fetchDeployMissionPlan } from "Slices/missionPlans";
import { getStopsByCurrentSemanticMap } from "Slices/stops";
import { getCurrentFleetId } from "Slices/missionPlanner";
import { DeployedMissionList } from "../../DeployedMissionList";
import { getCurrentSemanticMapId } from "Slices/appState";
import { getVdaActionDefinitions } from "Slices/vda_action_definitions";

export const DeployedMissionListModal = memo(() => {
  const [editData, setEditData] = useState(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const stops = useSelector(getStopsByCurrentSemanticMap);
  const currentFleetId = useSelector(getCurrentFleetId);
  const vdaActionDefinitions = useSelector(getVdaActionDefinitions);
  const semanticMapId = useSelector(getCurrentSemanticMapId);

  // Check currentFleetId existence before component rendered
  useLayoutEffect(() => {
    // Check if fleet ID exists in store OR in URL params
    const searchParams = new URLSearchParams(location.search);
    const fleetIdFromUrl = searchParams.get("fleetId");

    if (currentFleetId || fleetIdFromUrl) return;

    toast.error("Please specify particular fleet before create new mission!");
    handleCloseModal();
  }, [currentFleetId, location.search]);

  const handleDeployPlanMissionAction = useCallback(
    (data: { id: string }) => {
      if (!currentFleetId) return;

      dispatch(
        fetchDeployMissionPlan({
          ...data,
          currentFleetId,
        })
      );
    },
    [currentFleetId]
  );

  const handleCloseModal = useCallback(() => {
    dispatch(closeAnyModal());
  }, [dispatch]);

  return (
    <ModalStyled>
      <ModalBackgroundStyled onClick={handleCloseModal} />
      <MissionPlannerContainerStyled>
        <MissionPlannerContentStyled>
          <DeployedMissionList
            vehicleName={null}
            editData={editData}
            setEditData={setEditData}
            stops={stops}
            vehicleId={null}
            semanticMapId={semanticMapId}
            activeTab={"savedMission"}
            setActiveTab={null}
            deployPlanMissionAction={handleDeployPlanMissionAction}
            cancelAction={handleCloseModal}
            previousMode="Continue"
            vdaActionDefinitions={vdaActionDefinitions}
          />
        </MissionPlannerContentStyled>
      </MissionPlannerContainerStyled>
    </ModalStyled>
  );
});
